__webpack_require__.p = "https://start.guildeducation.com/";